import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Box } from '../../../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../../../../../../CommonComponents/OPL/Button/Button';

export enum Direction {
  Left,
  Right,
}

interface Props {
  direction: Direction;
  onClick(): void;
}

export const NavigationButtons = ({ direction, onClick }: Props) => {
  return (
    <AnimatePresence>
      <Box
        alignItems="center"
        animate={{ opacity: 1 }}
        as={motion.div}
        bottom="0"
        display="flex"
        exit={{ opacity: 0 }}
        initial={{ opacity: 0 }}
        justifyContent="center"
        key="NavigationButtons-left"
        position="absolute"
        top="0"
        zIndex="2"
        {...(direction === Direction.Left ? { left: 0 } : { right: 0 })}
      >
        <Button
          {...(direction === Direction.Left
            ? {
                leftIcon: 'fas fa-chevron-left',
              }
            : {
                rightIcon: 'fas fa-chevron-right',
              })}
          variant="secondary"
          onClick={onClick}
        >
          {direction === Direction.Left ? 'Intra-estate' : 'Outside Of Estate'}
        </Button>
      </Box>
    </AnimatePresence>
  );
};
